import { useState, useRef } from 'react';

interface RateLimitConfig {
  maxCalls: number;
  windowMs: number;
}

export function useRateLimit({ maxCalls, windowMs }: RateLimitConfig) {
  const [isLimited, setIsLimited] = useState(false);
  const callTimestamps = useRef<number[]>([]);

  const checkLimit = (): boolean => {
    const now = Date.now();
    callTimestamps.current = callTimestamps.current.filter(
      timestamp => now - timestamp < windowMs
    );

    if (callTimestamps.current.length >= maxCalls) {
      setIsLimited(true);
      const oldestCall = callTimestamps.current[0];
      const resetTime = oldestCall + windowMs - now;
      
      setTimeout(() => setIsLimited(false), resetTime);
      return false;
    }

    callTimestamps.current.push(now);
    return true;
  };

  const reset = () => {
    callTimestamps.current = [];
    setIsLimited(false);
  };

  return { checkLimit, isLimited, reset };
}
